
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2gcWA", function(module, exports) {

$parcel$export(module.exports, "getFCP", function () { return $1a571dcaedf1a0cb$export$52489892712e8192; });
$parcel$export(module.exports, "getCLS", function () { return $1a571dcaedf1a0cb$export$fc6227831ee7c7; });
$parcel$export(module.exports, "getFID", function () { return $1a571dcaedf1a0cb$export$134ed2977d320dfd; });
$parcel$export(module.exports, "getLCP", function () { return $1a571dcaedf1a0cb$export$da982ced0ff8a670; });
$parcel$export(module.exports, "getTTFB", function () { return $1a571dcaedf1a0cb$export$6e8eea9a35032c92; });
var $1a571dcaedf1a0cb$var$e, $1a571dcaedf1a0cb$var$t, $1a571dcaedf1a0cb$var$n, $1a571dcaedf1a0cb$var$i, $1a571dcaedf1a0cb$var$r = function(e, t) {
    return {
        name: e,
        value: void 0 === t ? -1 : t,
        delta: 0,
        entries: [],
        id: "v2-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12)
    };
}, $1a571dcaedf1a0cb$var$a = function(e, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            if ("first-input" === e && !("PerformanceEventTiming" in self)) return;
            var n = new PerformanceObserver(function(e) {
                return e.getEntries().map(t);
            });
            return n.observe({
                type: e,
                buffered: !0
            }), n;
        }
    } catch (e) {}
}, $1a571dcaedf1a0cb$var$o = function(e, t) {
    var n = function n(i) {
        "pagehide" !== i.type && "hidden" !== document.visibilityState || (e(i), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $1a571dcaedf1a0cb$var$u = function(e) {
    addEventListener("pageshow", function(t) {
        t.persisted && e(t);
    }, !0);
}, $1a571dcaedf1a0cb$var$c = function(e, t, n) {
    var i;
    return function(r) {
        t.value >= 0 && (r || n) && (t.delta = t.value - (i || 0), (t.delta || void 0 === i) && (i = t.value, e(t)));
    };
}, $1a571dcaedf1a0cb$var$f = -1, $1a571dcaedf1a0cb$var$s = function() {
    return "hidden" === document.visibilityState ? 0 : 1 / 0;
}, $1a571dcaedf1a0cb$var$m = function() {
    $1a571dcaedf1a0cb$var$o(function(e) {
        var t = e.timeStamp;
        $1a571dcaedf1a0cb$var$f = t;
    }, !0);
}, $1a571dcaedf1a0cb$var$v = function() {
    return $1a571dcaedf1a0cb$var$f < 0 && ($1a571dcaedf1a0cb$var$f = $1a571dcaedf1a0cb$var$s(), $1a571dcaedf1a0cb$var$m(), $1a571dcaedf1a0cb$var$u(function() {
        setTimeout(function() {
            $1a571dcaedf1a0cb$var$f = $1a571dcaedf1a0cb$var$s(), $1a571dcaedf1a0cb$var$m();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $1a571dcaedf1a0cb$var$f;
        }
    };
}, $1a571dcaedf1a0cb$export$52489892712e8192 = function(e, t) {
    var n, i = $1a571dcaedf1a0cb$var$v(), o = $1a571dcaedf1a0cb$var$r("FCP"), f = function(e) {
        "first-contentful-paint" === e.name && (m && m.disconnect(), e.startTime < i.firstHiddenTime && (o.value = e.startTime, o.entries.push(e), n(!0)));
    }, s = window.performance && performance.getEntriesByName && performance.getEntriesByName("first-contentful-paint")[0], m = s ? null : $1a571dcaedf1a0cb$var$a("paint", f);
    (s || m) && (n = $1a571dcaedf1a0cb$var$c(e, o, t), s && f(s), $1a571dcaedf1a0cb$var$u(function(i) {
        o = $1a571dcaedf1a0cb$var$r("FCP"), n = $1a571dcaedf1a0cb$var$c(e, o, t), requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                o.value = performance.now() - i.timeStamp, n(!0);
            });
        });
    }));
}, $1a571dcaedf1a0cb$var$p = !1, $1a571dcaedf1a0cb$var$l = -1, $1a571dcaedf1a0cb$export$fc6227831ee7c7 = function(e, t) {
    $1a571dcaedf1a0cb$var$p || ($1a571dcaedf1a0cb$export$52489892712e8192(function(e) {
        $1a571dcaedf1a0cb$var$l = e.value;
    }), $1a571dcaedf1a0cb$var$p = !0);
    var n, i = function(t) {
        $1a571dcaedf1a0cb$var$l > -1 && e(t);
    }, f = $1a571dcaedf1a0cb$var$r("CLS", 0), s = 0, m = [], v = function(e) {
        if (!e.hadRecentInput) {
            var t = m[0], i = m[m.length - 1];
            s && e.startTime - i.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (s += e.value, m.push(e)) : (s = e.value, m = [
                e
            ]), s > f.value && (f.value = s, f.entries = m, n());
        }
    }, h = $1a571dcaedf1a0cb$var$a("layout-shift", v);
    h && (n = $1a571dcaedf1a0cb$var$c(i, f, t), $1a571dcaedf1a0cb$var$o(function() {
        h.takeRecords().map(v), n(!0);
    }), $1a571dcaedf1a0cb$var$u(function() {
        s = 0, $1a571dcaedf1a0cb$var$l = -1, f = $1a571dcaedf1a0cb$var$r("CLS", 0), n = $1a571dcaedf1a0cb$var$c(i, f, t);
    }));
}, $1a571dcaedf1a0cb$var$T = {
    passive: !0,
    capture: !0
}, $1a571dcaedf1a0cb$var$y = new Date, $1a571dcaedf1a0cb$var$g = function(i, r) {
    $1a571dcaedf1a0cb$var$e || ($1a571dcaedf1a0cb$var$e = r, $1a571dcaedf1a0cb$var$t = i, $1a571dcaedf1a0cb$var$n = new Date, $1a571dcaedf1a0cb$var$w(removeEventListener), $1a571dcaedf1a0cb$var$E());
}, $1a571dcaedf1a0cb$var$E = function() {
    if ($1a571dcaedf1a0cb$var$t >= 0 && $1a571dcaedf1a0cb$var$t < $1a571dcaedf1a0cb$var$n - $1a571dcaedf1a0cb$var$y) {
        var r = {
            entryType: "first-input",
            name: $1a571dcaedf1a0cb$var$e.type,
            target: $1a571dcaedf1a0cb$var$e.target,
            cancelable: $1a571dcaedf1a0cb$var$e.cancelable,
            startTime: $1a571dcaedf1a0cb$var$e.timeStamp,
            processingStart: $1a571dcaedf1a0cb$var$e.timeStamp + $1a571dcaedf1a0cb$var$t
        };
        $1a571dcaedf1a0cb$var$i.forEach(function(e) {
            e(r);
        }), $1a571dcaedf1a0cb$var$i = [];
    }
}, $1a571dcaedf1a0cb$var$S = function(e) {
    if (e.cancelable) {
        var t = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, t) {
            var n = function() {
                $1a571dcaedf1a0cb$var$g(e, t), r();
            }, i = function() {
                r();
            }, r = function() {
                removeEventListener("pointerup", n, $1a571dcaedf1a0cb$var$T), removeEventListener("pointercancel", i, $1a571dcaedf1a0cb$var$T);
            };
            addEventListener("pointerup", n, $1a571dcaedf1a0cb$var$T), addEventListener("pointercancel", i, $1a571dcaedf1a0cb$var$T);
        }(t, e) : $1a571dcaedf1a0cb$var$g(t, e);
    }
}, $1a571dcaedf1a0cb$var$w = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(t) {
        return e(t, $1a571dcaedf1a0cb$var$S, $1a571dcaedf1a0cb$var$T);
    });
}, $1a571dcaedf1a0cb$export$134ed2977d320dfd = function(n, f) {
    var s, m = $1a571dcaedf1a0cb$var$v(), d = $1a571dcaedf1a0cb$var$r("FID"), p = function(e) {
        e.startTime < m.firstHiddenTime && (d.value = e.processingStart - e.startTime, d.entries.push(e), s(!0));
    }, l = $1a571dcaedf1a0cb$var$a("first-input", p);
    s = $1a571dcaedf1a0cb$var$c(n, d, f), l && $1a571dcaedf1a0cb$var$o(function() {
        l.takeRecords().map(p), l.disconnect();
    }, !0), l && $1a571dcaedf1a0cb$var$u(function() {
        var a;
        d = $1a571dcaedf1a0cb$var$r("FID"), s = $1a571dcaedf1a0cb$var$c(n, d, f), $1a571dcaedf1a0cb$var$i = [], $1a571dcaedf1a0cb$var$t = -1, $1a571dcaedf1a0cb$var$e = null, $1a571dcaedf1a0cb$var$w(addEventListener), a = p, $1a571dcaedf1a0cb$var$i.push(a), $1a571dcaedf1a0cb$var$E();
    });
}, $1a571dcaedf1a0cb$var$b = {}, $1a571dcaedf1a0cb$export$da982ced0ff8a670 = function(e, t) {
    var n, i = $1a571dcaedf1a0cb$var$v(), f = $1a571dcaedf1a0cb$var$r("LCP"), s = function(e) {
        var t = e.startTime;
        t < i.firstHiddenTime && (f.value = t, f.entries.push(e), n());
    }, m = $1a571dcaedf1a0cb$var$a("largest-contentful-paint", s);
    if (m) {
        n = $1a571dcaedf1a0cb$var$c(e, f, t);
        var d = function() {
            $1a571dcaedf1a0cb$var$b[f.id] || (m.takeRecords().map(s), m.disconnect(), $1a571dcaedf1a0cb$var$b[f.id] = !0, n(!0));
        };
        [
            "keydown",
            "click"
        ].forEach(function(e) {
            addEventListener(e, d, {
                once: !0,
                capture: !0
            });
        }), $1a571dcaedf1a0cb$var$o(d, !0), $1a571dcaedf1a0cb$var$u(function(i) {
            f = $1a571dcaedf1a0cb$var$r("LCP"), n = $1a571dcaedf1a0cb$var$c(e, f, t), requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    f.value = performance.now() - i.timeStamp, $1a571dcaedf1a0cb$var$b[f.id] = !0, n(!0);
                });
            });
        });
    }
}, $1a571dcaedf1a0cb$export$6e8eea9a35032c92 = function(e) {
    var t, n = $1a571dcaedf1a0cb$var$r("TTFB");
    t = function() {
        try {
            var t = performance.getEntriesByType("navigation")[0] || function() {
                var e = performance.timing, t = {
                    entryType: "navigation",
                    startTime: 0
                };
                for(var n in e)"navigationStart" !== n && "toJSON" !== n && (t[n] = Math.max(e[n] - e.navigationStart, 0));
                return t;
            }();
            if (n.value = n.delta = t.responseStart, n.value < 0 || n.value > performance.now()) return;
            n.entries = [
                t
            ], e(n);
        } catch (e) {}
    }, "complete" === document.readyState ? setTimeout(t, 0) : addEventListener("load", function() {
        return setTimeout(t, 0);
    });
};

});


//# sourceMappingURL=web-vitals.9550d271.js.map
